import { GET_ADDRESS_DETAILS, SET_ADDRESS_DETAILS} from "./AddressDetailsType";

const getAddressDetails = (state: any, target?: string) => ({
    type: GET_ADDRESS_DETAILS,
    state,
    target
});

const setAddressDetails = (addressDetails: any, target?: string) => ({
    type: SET_ADDRESS_DETAILS,
    addressDetails,
    target
});

export {
    getAddressDetails,
    setAddressDetails
}